<template>
  <div>
    <SectionTitle>
      Assista até o final e descubra como funciona:
    </SectionTitle>

    <div class="video-wrap mt-6">
      <iframe
        src="https://www.youtube-nocookie.com/embed/23Qyx9lit54"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        title="Como Funciona"
        class="video-frame"
      />
    </div>
  </div>
</template>

<script>
import SectionTitle from "@/components/SectionTitle.vue";

export default {
  name: 'HowWorkVideo',
  components: { SectionTitle },
};
</script>

<style scoped>
  /* Container centraliza e limita a largura */
  .video-wrap {
    display: flex;
    justify-content: center;
  }

  .video-frame {
    width: 100%;
    max-width: 720px;
    aspect-ratio: 16 / 9;
    height: auto;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  }

  @media (max-width: 740px) {
    .video-frame {
      border-radius: 12px;
    }
  }
</style>
